// api-cache.interceptor.ts
import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApiCacheService } from '@core/services/cache/api-cache.service';
import { Log } from '@core/services/config/app-config.service';
import { of, tap } from 'rxjs';

export const apiCacheInterceptor: HttpInterceptorFn = (req, next) => {
    const apiCacheService = inject(ApiCacheService);

    if (!apiCacheService.isCachable(req)) {
        return next(req);
    }

    const cachedResponse = apiCacheService.getFromCache(req);

    if (cachedResponse) {
        return of(cachedResponse);
    }

    // Invia una richiesta e memorizza la risposta nella cache
    return next(req).pipe(
        tap(event => {
            if (event instanceof HttpResponse && event.status === 200) {
                apiCacheService.putInCache(req, event);
            }
        })
    );
};